import { render, staticRenderFns } from "./ProviderDocumentationCard.vue?vue&type=template&id=7458ca1a&"
import script from "./ProviderDocumentationCard.vue?vue&type=script&lang=js&"
export * from "./ProviderDocumentationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports